import { useMemo } from 'react';
import { InventorySortingField } from '../../../api/types';
import makeGetSortingRule from '../../../utilities/makeGetSortingRule';

export const getSortField = makeGetSortingRule((field): InventorySortingField => {
    switch (field) {
        case 'module.company.displayName':
            return InventorySortingField.Company;

        case 'module.displayName':
            return InventorySortingField.ModuleName;

        case 'model.name':
            return InventorySortingField.ModelName;

        case 'subModel.name':
            return InventorySortingField.SubModelName;

        case 'variant.name':
            return InventorySortingField.VariantName;

        case 'colorSetting.name.defaultValue':
            return InventorySortingField.ConfiguratorColorName;

        case 'trimSetting.name.defaultValue':
            return InventorySortingField.ConfiguratorTrimName;

        case 'packageSetting.packageName.defaultValue':
            return InventorySortingField.ConfiguratorPackageName;

        case 'assignedVinCount':
            return InventorySortingField.AssignedVinCount;

        default:
            throw new Error('Unknown Sorting Field!');
    }
});

const useSortOrder = sort => {
    const companySort = useMemo(
        () => (sort.field === InventorySortingField.Company ? sort.orderValue : undefined),
        [sort]
    );

    const moduleSort = useMemo(
        () => (sort.field === InventorySortingField.ModuleName ? sort.orderValue : undefined),
        [sort]
    );

    const modelNameSort = useMemo(
        () => (sort.field === InventorySortingField.ModelName ? sort.orderValue : undefined),
        [sort]
    );

    const subModelSort = useMemo(
        () => (sort.field === InventorySortingField.SubModelName ? sort.orderValue : undefined),
        [sort]
    );

    const variantNameSort = useMemo(
        () => (sort.field === InventorySortingField.VariantName ? sort.orderValue : undefined),
        [sort]
    );

    const configuratorColorNameSort = useMemo(
        () => (sort.field === InventorySortingField.ConfiguratorColorName ? sort.orderValue : undefined),
        [sort]
    );

    const configuratorTrimNameSort = useMemo(
        () => (sort.field === InventorySortingField.ConfiguratorTrimName ? sort.orderValue : undefined),
        [sort]
    );

    const configuratorPackageNameSort = useMemo(
        () => (sort.field === InventorySortingField.ConfiguratorPackageName ? sort.orderValue : undefined),
        [sort]
    );

    const assignedVinCountSort = useMemo(
        () => (sort.field === InventorySortingField.AssignedVinCount ? sort.orderValue : undefined),
        [sort]
    );

    return {
        companySort,
        moduleSort,
        modelNameSort,
        subModelSort,
        variantNameSort,
        configuratorColorNameSort,
        configuratorTrimNameSort,
        configuratorPackageNameSort,
        assignedVinCountSort,
    };
};

export default useSortOrder;
